module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h1', [_vm._v("Grid")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("栅格")])]), _vm._v(" "), _c('h2', [_vm._v("概念")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("24 栅格系统")])]), _vm._v(" "), _c('Row', {
    staticClass: "grid-concept-demo",
    attrs: {
      "gutter": 1
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")])], 1), _vm._v(" "), _c('Row', {
    staticClass: "grid-concept-demo",
    attrs: {
      "gutter": 1
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")])], 1), _vm._v(" "), _c('Row', {
    staticClass: "grid-concept-demo",
    attrs: {
      "gutter": 1
    }
  }, [_c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")])], 1), _vm._v(" "), _c('h2', [_vm._v("代码示例")]), _vm._v(" "), _c('test'), _vm._v(" "), _c('h2', [_vm._v("API")]), _vm._v(" "), _c('h3', [_vm._v("Row")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Col")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("gutter")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格间隔")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("span")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格格数，为"), _c('code', [_vm._v("0")]), _vm._v("时为"), _c('code', [_vm._v("display: none")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("offset")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格往右偏移个数")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("push")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格往右移动个数，原占位不变")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("pull")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("栅格往左移动个数，原占位不变")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String")])]), _vm._v(" "), _c('td', [_vm._v("0")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("xsm")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v("<768px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sm")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=768px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("md")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=992px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("lg")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=1200px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("xlg")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('code', [_vm._v(">=1600px")]), _vm._v(" 响应式栅格，可为栅格格数 或 一个包含多个属性的对象")]), _vm._v(" "), _c('td', [_c('code', [_vm._v("Number|String|Object")])]), _vm._v(" "), _c('td', [_vm._v("-")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-501ee0f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/index-23.vue
// module id = 656
// module chunks = 0